import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { compose } from 'recompose';
import { form, FormProps } from '../../../../utils/form';
import SubmitButton from '../../../../components/SubmitButton';
import { constraints, FormData } from './constraints';
import { routine } from './actions';
import { validate } from '../../../../utils/validators';
import { Input } from 'shared/components/Input';
import { FieldSet } from 'shared/components/FieldSet';
import { PasswordInput } from 'shared/components/PasswordInput';
import { Link } from 'shared/components/Link';

import './index.scss';

export interface Props {
  selectResetPasswordTab: () => void;
}

type Enhanced = Props & FormProps<FormData, Props>;

const b = b_.with('login-and-password-form');

const enhance = compose<Enhanced, Props>(
  form<FormData, Props>(routine, {
    form: 'signUpLoginAndPassword',
    validate: (values) => validate(constraints, values),
  })
);

const LoginAndPassword: React.FC<Enhanced> = ({
  formSubmit,
  selectResetPasswordTab,
  submitting,
  error,
}) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={formSubmit} method="POST" data-testid="signin-popup-login-step">
      <FieldSet>
        <Input
          name="username"
          label={t('Username / Email')}
          autoFocus
          tooltipPlacement="bottomLeftSticky"
        />
        <PasswordInput name="password" label={t('Password')} tooltipPlacement="bottomLeftSticky" />
      </FieldSet>
      <div className={b('buttons')}>
        <SubmitButton className={b('btn', { primary: true })} submitting={submitting} error={error}>
          {t('Sign in')}
        </SubmitButton>
        <button
          className={b('btn', { secondary: true })}
          type="button"
          tabIndex={-1}
          onClick={selectResetPasswordTab}
          data-gtm="authform-resetpassword-tab"
          data-testid="reset-password-btn"
        >
          {t('Reset the password')}
        </button>
        <p className="text-secondary">
          {t('By clicking Log In you accept')}{' '}
          <Link to="/offer" target="_blank">
            {t('Licence Agreement')}
          </Link>
        </p>
      </div>
    </form>
  );
};

export default enhance(LoginAndPassword);
